module.exports = "<div class=\"modal-header\">\r\n  <h4 class=\"modal-title\">{{view_title}}</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n    <div class=\"scrollarea mailviewarea\">\r\n          <span [innerHTML]=\"view_text|questionBreakHtml\"></span>\r\n    </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-dark\" (click)=\"modalCloseOK()\">OK</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0106-mail/a-view-text-modal.component.html
// module id = ./src/app/a0106-mail/a-view-text-modal.component.html
// module chunks = main